export function addToSessionStorage(key, value) {
  if (typeof value === "object") {
    sessionStorage.setItem(key, JSON.stringify(value));
  } else {
    sessionStorage.setItem(key, value);
  }
}

export function getFromSessionStorage(key) {
  const value = sessionStorage.getItem(key);
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
}

export function removeFromSessionStorage(key) {
  sessionStorage.removeItem(key);
}
